import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {merchantsView_template} from "../components/templates/merchantsView_template";

declare var ko: any;
declare var page: any;

export class merchant_view extends vnModule_knockoutJS {

    protected merchantsViewTemplate: merchantsView_template;
    protected XHRHdl: XMLHttpRequestHandler;

    buildContent(): Element[] {
        this.merchantsViewTemplate = new merchantsView_template("merchant_view_template", this.viewModel, this);
        return [this.merchantsViewTemplate.build()];
    }

    protected getModuleName(): string {
        return "merchant_view";
    }

    fillPage() {
        this.getMerchantDataForView();
    }

    private getMerchantDataForView() {
        this.loadingIn(this.merchantsViewTemplate.builtTemplate);

        const idBrand = this.getVnAppZone().app.params.idBrand;
        const merchantId = this.getVnAppZone().app.params.merchantId;

        const url: string = '/api/discounts/merchants/get/' + merchantId + '/';
        const request_parameters: string[][] = [];
        request_parameters.push(["data", ko.toJSON({ brandId: idBrand })]);

        this.XHRHdl = new XMLHttpRequestHandler(url, request_parameters, this);
        this.XHRHdl.onReadyStateFunction = this.onGetMerchantDataForView;
        this.XHRHdl.execute();
    }

    private onGetMerchantDataForView(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response);

                if (responseParsed.merchant) {
                    obj.merchantsViewTemplate.setMerchantData(responseParsed.merchant);
                } else if (responseParsed.id) {
                    obj.merchantsViewTemplate.setMerchantData(responseParsed);
                }

                obj.loadingOut(obj.merchantsViewTemplate.builtTemplate);
            });
        };
    }

    protected onClickEditMerchant(id) {
        const brandId = this.getVnAppZone().app.params.idBrand;
        page("/brand/" + brandId + "/config/merchants/edit/" + id + '/');
    }

    protected onClickCancel() {
        const brandId = this.getVnAppZone().app.params.idBrand;
        page.redirect("/brand/" + brandId + "/config/merchants/");
    }
}



// WEBPACK FOOTER //
// ./js/modules/merchant_view.ts